import { History } from 'history'
import * as React from 'react'
import { Provider } from 'react-redux'
import { renderRoutes } from 'react-router-config'
import { ConnectedRouter } from 'react-router-redux'
import { Store } from 'redux'

import { IRootState } from '../common/reducers'
import { newRoutes, oldRoutes } from '../common/routes'
import { logError } from '../common/utils/errors'
import { hasFeature } from '../common/utils/features'
import PendingNavDataLoaderContainer from './containers/pendingNavDataLoaderContainer'

interface IProps {
  store: Store<IRootState>
  history: History
}

interface IState {
  hasError: boolean
  hasMounted: boolean
}

class App extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.state = {
      hasError: false,
      hasMounted: false
    }
  }

  public componentDidCatch(error: Error) {
    this.setState({ hasError: true })
    // send this to rollbar later
    logError(error)
  }

  public componentDidMount() {
    // used for the purpose of smoke tests to ensure
    // our bundle is functional
    this.setState({ hasMounted: true })
  }

  public render() {
    const { store, history } = this.props
    const {
      common: { currentSite },
      experiments,
      router: { location }
    } = store.getState()

    const newRoutesEnabled = hasFeature(
      'routes:new',
      currentSite,
      location,
      experiments
    )

    let routes = oldRoutes

    if (newRoutesEnabled) {
      routes = newRoutes
    }

    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <PendingNavDataLoaderContainer store={store} routes={routes}>
            {renderRoutes(routes)}
            {this.state.hasMounted ? <span data-mounted="mounted" /> : null}
          </PendingNavDataLoaderContainer>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default App
